import React from "react";

const PlayIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.68 9.41C11.89 9.29 12.15 9.30 12.36 9.43L21.69 15.43C21.88 15.56 22.00 15.77 22.00 16.00C22.00 16.22 21.88 16.43 21.69 16.56L12.36 22.56C12.15 22.69 11.89 22.70 11.68 22.58C11.46 22.46 11.33 22.24 11.33 22.00V10.00C11.33 9.75 11.46 9.53 11.68 9.41Z"
      fill={fillColor}
    />
  </svg>
);

export default PlayIcon;
